import { useTheme } from '@chakra-ui/react';

const useModalPaddings = (isMobile: boolean) => {
  const theme = useTheme();

  const mobileBoxPadding = {
    pt: theme.size?.container?.mobile.y2,
    px: theme.size?.container?.mobile.x,
    pb: theme.size?.container?.mobile.x,
  };

  const deskBoxPadding = {
    pt: theme.size?.container?.desktop.y2,
    px: theme.size?.container?.desktop.x,
    pb: theme.size?.container?.desktop.x,
  };

  return isMobile ? mobileBoxPadding : deskBoxPadding;
};

export default useModalPaddings;
